import {
  AlertController,
  IonicModule,
  ModalController,
  NavController,
} from "@ionic/angular";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { CadastroBuscaControlePage } from "./cadastro-busca-controle/cadastro-busca-controle.page";
import { CadastroBuscaCodigoPage } from "./cadastro-busca-codigo/cadastro-busca-codigo.page";
import { InstituicaoProvider } from "src/app/services/instituicao/instituicao";
import { RecuperarSenhaPage } from "./recuperar-senha/recuperar-senha.page";
import { AplicativoProvider } from "src/app/services/aplicativo/aplicativo";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { FormGeradorPage } from "../form-gerador/form-gerador.page";
import { Component, OnInit, ViewChild } from "@angular/core";
import { environment } from "src/environments/environment";
import { UserProvider } from "src/app/services/user/user";
import { CommonModule } from "@angular/common";
import { Browser } from "@capacitor/browser";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { AutoCadastroPage } from "./auto-cadastro/auto-cadastro";
import { addIcons } from 'ionicons';
import { eyeOffOutline, eyeOutline } from 'ionicons/icons';

declare var instituicaoConstants: {
  MOSTRAR_BANDEIRA: boolean;
  INSTITUICAO: number;
  IS_PWA: boolean;
  BUSCAR_INTITUICOES: number;
};

@Component({
  selector: "app-login",
  templateUrl: "./login.page.html",
  styleUrls: ["./login.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule,
  ],
})
export class LoginPage implements OnInit {
  login: FormGroup;
  esconderCadastro = true;
  esconderFacebook = true;
  senhaEscondida = true;
  carregado = false;
  animator = true;
  error = false;
  home: any;
  @ViewChild("divLogin")
  divLogin!: { nativeElement: HTMLElement };
  isAnonimo: any;
  isMessianica = false;

  constructor(
    public nav: NavController,
    public userProvider: UserProvider,
    public modalCtrl: ModalController,
    public instituicaoProvider: InstituicaoProvider,
    public translate: TranslateService,
    public router: Router,
    public alertCtrl: AlertController,
    private location: Location,
    public aplicativoProvider: AplicativoProvider
  ) {
    addIcons({
      'eye-off-outline': eyeOffOutline,
      'eye-outline': eyeOutline
    });

    this.isMessianica = environment.isMessianica;

    if (instituicaoConstants.INSTITUICAO != 0) {
      this.userProvider
        .esconderCadastro(instituicaoConstants.INSTITUICAO)
        .subscribe((data) => {
          this.esconderCadastro = data;
        });

      this.userProvider
        .esconderFB(instituicaoConstants.INSTITUICAO)
        .subscribe((data) => {
          this.esconderFacebook = data;
        });
    } else {
      this.esconderCadastro = false;

      this.userProvider.esconderFBProver().subscribe((data) => {
        this.esconderFacebook = data;
      });
    }

    setTimeout(() => {
      this.animator = true;
      this.carregado = true;
    }, 1000);

    this.login = new FormGroup({
      usuario: new FormControl("", Validators.required),
      password: new FormControl("", Validators.required),
    });
  }

  ngOnInit() {
    this.isAnonimo = this.userProvider.isAnonimo();
  }

  togglePasswordText() {
    const input = document.querySelector('ion-input[formControlName="password"]') as any;
    const currentValue = input.value;
    this.senhaEscondida = !this.senhaEscondida;

    setTimeout(() => {
      input.value = currentValue;
    });
  }

  async goToForgotPassword() {
    let data = { modal: true };
    const modal = await this.modalCtrl.create({
      component: RecuperarSenhaPage,
      componentProps: data,
    });
    modal.present();
  }

  doLogin(val: { usuario: string; password: string }) {
    const instituicaoId =
      instituicaoConstants.INSTITUICAO !== 0
        ? instituicaoConstants.INSTITUICAO
        : 1;

    const usuario = {
      usuario: val.usuario,
      senha: val.password,
      instituicao: instituicaoId,
    };

    this.userProvider.login(usuario).subscribe(
      (login): any => {
        if (login.error) {
          this.error = true;
          return;
        }

        this.userProvider.sendMessage("tabs");
        const currentUrl = this.location.path();
        const baseUrl = currentUrl.split("/")[1];

        if (baseUrl === "tabs") {
          !login.error ? this.modalCtrl.dismiss(true) : (this.error = true);
        } else {
          !login.error ? this.router.navigate(["tabs"]) : (this.error = true);
        }
      },
      (error) => {
        console.error("Error during login:", error);
        this.error = true;
      }
    );
  }

  getBackground(): string {
    return `
      linear-gradient(var(--login-gradiente_inicio), var(--login-gradiente_fim)),
      url('/assets/login.png') center center / cover no-repeat
    `;
  }

  async goToSignup(facebook: any) {
    if (instituicaoConstants.BUSCAR_INTITUICOES == 0) {
      this.goToSignupCadastro(facebook);
    } else if (instituicaoConstants.BUSCAR_INTITUICOES == 2) {
      this.goToSignupControle();
    } else {
      this.goToSignupCodigo();
    }
  }

  private async goToSignupCadastro(facebook: null) {
    this.instituicaoProvider
      .getInstituicaoCadastro(instituicaoConstants.INSTITUICAO)
      .subscribe(async (data) => {
        if (data) {
          const cadastro: any = {};
          cadastro.form = "APP_CAD_INICIO";
          cadastro.idPessoaTipo = 5;
          cadastro.titulo = this.translate.instant("Novo Cadastro");
          cadastro.idInstituicao = data.id;
          cadastro.facebook = facebook;
          cadastro.hideFacebook = this.esconderFacebook;

          const modalCadastro = await this.modalCtrl.create({
            component: FormGeradorPage,
            componentProps: cadastro,
            animated: false,
          });
          modalCadastro.present();
          const result = await modalCadastro.onDidDismiss();
          if (result.data) {
            this.setRouter();
          }
        } else {
          this.error = true;
        }
      });
  }

  private async goToSignupControle() {
    if (this.isMessianica) {
      const modalPageMessianica = await this.modalCtrl.create({
        component: AutoCadastroPage,
      });

      modalPageMessianica.present();
      const data = await modalPageMessianica.onDidDismiss();
      if (data.data) {
        this.setRouter();
      }
    } else {
      const modalPage = await this.modalCtrl.create({
        component: CadastroBuscaControlePage,
        componentProps: { facebook: undefined },
        animated: false,
      });
      modalPage.present();

      const data = await modalPage.onDidDismiss();
      if (data.data) {
        this.setRouter();
      }
    }
  }

  private async goToSignupCodigo() {
    const modalPageCadastro = await this.modalCtrl.create({
      component: CadastroBuscaCodigoPage,
      componentProps: { facebook: undefined },
      animated: false,
    });
    modalPageCadastro.present();

    const data = await modalPageCadastro.onDidDismiss();
    if (data.data) {
      this.modalCtrl.dismiss();
      this.setRouter();
    }
  }

  loginFacebook() {
    let permissions = new Array<string>();
    permissions = ["public_profile", "email"];

    // this.facebook.login(permissions).then((response: FacebookLoginResponse) => {
    //   let params = new Array<string>();
    //   this.facebook.api("/me?fields=name,email", params)
    //     .then(res => {

    //       let usuario: any = {};
    //       usuario.nome = res.name;
    //       usuario.email = res.email;
    //       usuario.id = res.id;
    //       usuario.foto = 'https://graph.facebook.com/' + res.id + '/picture?type=normal'
    //       usuario.token = response.authResponse.accessToken;
    //       this.logar(usuario);
    //     }, (error) => {
    //       console.log('ERROR: ', error);
    //     })
    // }, (error) => {
    //   console.log('ERROR: ', error);
    // });
  }

  async logar(facebook: any) {
    var usuario = {};
    usuario =
      instituicaoConstants.INSTITUICAO != 0
        ? { facebook: facebook, instituicao: instituicaoConstants.INSTITUICAO }
        : { facebook: facebook, instituicao: 1 };

    this.userProvider.login(usuario).subscribe(async (login) => {
      if (!login.error) {
        this.setRouter();
      } else if (!login.redirectCadastro) {
        this.alert(this.translate.instant(login.message));
      } else if (login.redirectCadastro) {
        this.alert(
          this.translate.instant(
            "Nenhum usuário encontrado vinculado a esse facebook"
          )
        );
      }
    });
  }

  async alert(message: any) {
    const alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Erro"),
      subHeader: message,
      buttons: ["OK"],
    });
    alert.present();
  }

  setRouter() {
    this.userProvider.sendMessage("tabs");
    const currentUrl = this.location.path();
    const baseUrl = currentUrl.split("/")[1];

    if (baseUrl === "tabs") {
      this.modalCtrl.dismiss(true);
    } else {
      this.router.navigate(["tabs"]);
    }
  }

  async closeModal() {
    const currentUrl = this.location.path();
    const baseUrl = currentUrl.split("/")[1];

    if (baseUrl === "tabs") {
      this.modalCtrl.dismiss(false);
    } else {
      this.router.navigate(["tabs"]);
    }
  }

  async onboarding() {
    const currentUrl = this.location.path();
    const baseUrl = currentUrl.split("/")[1];

    if (baseUrl === "tabs") {
      this.modalCtrl.dismiss(false);
    } else {
      this.router.navigate(["onboarding"]);
    }
  }

  async openEndereco() {
    await Browser.open({
      url: "https://www.messianica.org.br/nossas-unidades",
    });
  }

  user() {
    this.error = false;
  }
}
